let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Gvba")).then(() => parcelRequire('eVLC0'));